import { render, staticRenderFns } from "./LogoContainer.vue?vue&type=template&id=5d8d9f85&"
import script from "./LogoContainer.vue?vue&type=script&lang=js&"
export * from "./LogoContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports